// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2pycz","productName":"Table_productName__1RiTl"};